import { Observable } from "rxjs";
import { Component } from "@angular/core";
import { Subscription } from "rxjs";
import { MediaObserver, MediaChange } from "@ngbracket/ngx-layout";

import {
  Router,
  Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from '@angular/router'
import { AuthService } from "./services/auth/auth.service";
import { MatDialog } from "@angular/material/dialog";
import { RunModalComponent } from "./shared/components/run-modal/run-modal.component";
import { LoaderService } from "./services/loader.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent {
  isLoggedIn$: Observable<boolean>;
  opened = true;
  over = "side";
  expandHeight = "42px";
  collapseHeight = "42px";
  displayMode = "flat";
  watcher: Subscription;

  constructor(media: MediaObserver,
    private authService: AuthService,
    private dialog: MatDialog,
    router: Router,
    private loaderService: LoaderService) {

    router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event)
    });

    this.watcher = media.asObservable().subscribe((change: MediaChange[]) => {

      change.sort((a, b) => {
        return a.priority > b.priority ? 1 : 0;
      });

      //Verificar a mudança com maior prioridade para ser aplicada
      const item: MediaChange = change[0];

      if (item.mqAlias === "sm" || item.mqAlias === "xs") {
        this.opened = false; // ALTERADO this.opened = false -- true
        this.over = "over"; // ALTERADO this.over = "over" -- side
      } else {
        this.opened = true;
        this.over = "side";
      }
    });


  }

  ngOnInit() {
    this.isLoggedIn$ = this.authService.isLoggedIn;

    window.addEventListener('keydown', (event: KeyboardEvent) => {
      // Fall back to event.which if event.keyCode is null
      if (event) {
        const keycode = event.key;
        if (keycode && keycode.toLowerCase() === "d" && event.ctrlKey && event.altKey) {
          this.abreModalExecucao();
        }
      }
    });
  }

  abreModalExecucao() {
    this.dialog.open(RunModalComponent, {
      height: '280px',
      width: '850px',
      data: {}
    });
  }

  getSideNav() {
    if (this.opened) {
      this.opened = false; // ALTERADO this.opened = false
    } else {
      this.opened = true;
    }
  }

  // Shows and hides the loading spinner during RouterEvent changes
  navigationInterceptor(event: RouterEvent): void {

    switch (event.constructor) {
      case NavigationStart: this.loaderService.setLoading(true); break;
      case NavigationEnd: this.loaderService.setLoading(false); break;
      case NavigationCancel: this.loaderService.setLoading(false); break;
      case NavigationError: this.loaderService.setLoading(false); break;
      default:
        break;
    }
  }
}